var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPtinline = function SvgPtinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pt_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M0 9a9 9 0 0 0 5.87 8.44L6.652 9 5.87.56A9 9 0 0 0 0 9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M18 9A9 9 0 0 0 5.87.56v16.88A9 9 0 0 0 18 9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M5.87 12.13a3.13 3.13 0 1 0 0-6.26 3.13 3.13 0 0 0 0 6.26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M4.108 7.435V9.39a1.76 1.76 0 1 0 3.522 0V7.435z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M5.87 9.978a.59.59 0 0 1-.588-.587v-.783h1.174v.783a.59.59 0 0 1-.587.587"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pt_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgPtinline;